import { render, staticRenderFns } from "./HistoricDateFilter.vue?vue&type=template&id=96dfac44&scoped=true&"
import script from "./HistoricDateFilter.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./HistoricDateFilter.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./HistoricDateFilter.vue?vue&type=style&index=0&id=96dfac44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96dfac44",
  null
  
)

export default component.exports